import { enUS } from './en-US';
import { zhCN } from './zh-CN';
import { services } from '@comall-backend-builder/core';

export const LanguageConfig = {
    enUS,
    zhCN,
};
const language = services.language;
export { language };
